import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import Pricing from "../components/Pricing";
import Statement from "../components/Statement";

import { PubNub } from "../api/Realtime";
import API from "../api";
import World from "../world";

const pubNubSubKey = process.env.NEXT_PUBLIC_PUB_NUB_SUB_KEY;
const pn = new PubNub(pubNubSubKey);
const api = new API(pn);
const world = new World(api, {});

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>TacBoard Pricing</title>
            <meta name="description" content="Live photo stream, unique phone number, online gallery and free sign shop are included in the price." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
           <link rel="canonical" href="https://tacboard.com/tacboard-pricing" />
        </Head>

      <Layout classes={["pricing", "public"]}>
        <Header />
        <Pricing world={world} />
        <Statement />
        <Footer noNav/>
      </Layout>
    </>
  );
};
